import React, { useEffect, Suspense, lazy } from 'react';
// import { FaRegLightbulb } from "react-icons/fa";
// import { TiInputChecked } from "react-icons/ti";

import { graphql, useStaticQuery } from 'gatsby';
import {
  TestimonialsContainer,
  TopLine,
  Description,
  ContentWrapper,
  ColumnOne,
  Testimonial,
  ColumnTwo,
  Images,
  TestimonialImageCard,
} from './style';
import AOS from 'aos';
import 'aos/dist/aos.css';
const Testmonial = () => {
  useEffect(() => {
    AOS.init({
      duration: 600,
    });
    AOS.refresh();
  }, []);
  const data = useStaticQuery(graphql`
    query {
      allFile(
        filter: { ext: { regex: "/jpg/" }, name: { in: ["sarah", "sean"] } }
      ) {
        edges {
          node {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid
              }
              fixed(height: 300, width: 300) {
                ...GatsbyImageSharpFixed
              }
              id
            }
          }
        }
      }
    }
  `);
  return (
    <TestimonialsContainer
      data-aos="zoom-in"
      data-aos-offset="100"
      data-aos-delay="20"
      data-aos-easing="ease-in-out"
      data-aos-mirror="true"
      data-aos-once="false"
      data-aos-anchor-placement="top-bottom"
    >
      <TopLine>Testimonial</TopLine>
      <Description>
        Here It's a demo testimonial! As soon we get real data. Every thing will
        be shown accordingly. Have patience and business more.
      </Description>
      <ContentWrapper>
        <ColumnOne>
          <Testimonial
            data-aos="zoom-in"
            data-aos-offset="100"
            data-aos-delay="20"
            data-aos-easing="ease-in-out"
            data-aos-mirror="true"
            data-aos-once="false"
            data-aos-anchor-placement="top-bottom"
          >
            {/* <TiInputChecked /> */}
            <h3>Sean Michels</h3>
            <p>
              Great Experience! Well I was expecting just a car repair service
              site. But It's seems now I have complete emommerce site with seo.
              I am really happy with service. Thank you!
            </p>
          </Testimonial>
          <Testimonial
            data-aos="zoom-in"
            data-aos-offset="100"
            data-aos-delay="20"
            data-aos-easing="ease-in-out"
            data-aos-mirror="true"
            data-aos-once="false"
            data-aos-anchor-placement="top-bottom"
          >
            {/* <FaRegLightbulb /> */}
            <h3>Sarah Kin</h3>
            <p>
              Nice Job! My old portfolio and blog causing many problems. I went
              many service providers they all asked for making new one. Which
              could cause huge. And I really dont need new site for my bolg and
              portpolio again. But Now It's fixed. It's performing well. Thank
              you sir!
            </p>
          </Testimonial>
        </ColumnOne>
        <ColumnTwo>
          {data.allFile.edges.map((item, index) => (
            <TestimonialImageCard
              data-aos="zoom-in"
              data-aos-offset="100"
              data-aos-delay="20"
              data-aos-easing="ease-in-out"
              data-aos-mirror="true"
              data-aos-once="false"
              data-aos-anchor-placement="top-bottom"
            >
              <Images
                key={index}
                fluid={item.node.childImageSharp.fluid}
                // fixed={item.node.childImageSharp.fixed}
              />
            </TestimonialImageCard>
          ))}
        </ColumnTwo>
      </ContentWrapper>
    </TestimonialsContainer>
  );
};

export default Testmonial;
